import { todosService } from '@deliveries-app/services';
import toast from 'react-hot-toast';
import { TodoActionTypes } from './actionTypes';

/**
 * Get all todos action
 *
 * @param {number} branch_id
 * @param {string} date
 *
 * @returns {Promise<void>}
 */
export function getTodos(branch_id: number, date: string) {
  console.log(
    `Dispatch getTodos action for branch id ${branch_id} and date ${date}`
  );

  return async (dispatch) => {
    dispatch({ type: TodoActionTypes.TODO_REQUEST });
    try {
      const todos = await todosService.getAllTodos(branch_id, date);

      dispatch({ type: TodoActionTypes.GET_ALL_TODOS_SUCCESS, payload: todos });
    } catch (error) {
      dispatch({ type: TodoActionTypes.GET_ALL_TODOS_FAILURE, payload: error });
    }
  };
}

/**
 * Create a new Todo items
 *
 * @param {number} branch_id
 * @param {string} date
 * @param {string} content
 *
 * @returns {Promise<void>}
 */
export function createTodo(branch_id: number, date: string, content: string) {
  console.log(
    `Dispatch createTodo action for branch id ${branch_id} and date ${date}`
  );

  return async (dispatch) => {
    dispatch({ type: TodoActionTypes.TODO_REQUEST });
    try {
      const promise = todosService.createTodo(branch_id, date, content);

      toast.promise(promise, {
        loading: 'Saving todo...',
        success: (todo) => {
          dispatch({
            type: TodoActionTypes.CREATE_TODO_SUCCESS,
            payload: todo,
          });
          return 'Todo created!';
        },
        error: (error) => {
          dispatch({
            type: TodoActionTypes.CREATE_TODO_FAILURE,
            payload: error,
          });
          return 'Error saving todo';
        },
      });
    } catch (error) {
      dispatch({ type: TodoActionTypes.CREATE_TODO_FAILURE, payload: error });
    }
  };
}

/**
 * Update a Todo Item
 *
 * @param {number} branch_id
 * @param {number} todo_id
 * @param {string} content
 * @param {boolean} completed
 *
 * @returns {Promise<void>}
 */
export function updateTodo(
  branch_id: number,
  todo_id: number,
  content: string,
  completed: boolean
) {
  console.log(
    `Dispatch updateTodo action for branch id ${branch_id} and todo id ${todo_id}`
  );

  return async (dispatch) => {
    dispatch({ type: TodoActionTypes.TODO_REQUEST });
    try {
      const promise = todosService.updateTodo(
        branch_id,
        todo_id,
        content,
        completed
      );

      toast.promise(promise, {
        loading: 'Updating todo...',
        success: (completed_at) => {
          dispatch({
            type: TodoActionTypes.UPDATE_TODO_SUCCESS,
            payload: {
              id: todo_id,
              completed: completed_at,
            },
          });
          return 'Todo updated!';
        },
        error: (error) => {
          dispatch({
            type: TodoActionTypes.UPDATE_TODO_FAILURE,
            payload: error,
          });
          console.log(error);
          return 'Error updating todo';
        },
      });
    } catch (error) {
      dispatch({ type: TodoActionTypes.UPDATE_TODO_FAILURE, payload: error });
      console.log(error);
    }
  };
}

/**
 * Delete a Todo item
 *
 * @param {number} branch_id
 * @param {number} todo_id
 *
 * @returns {Promise<void>}
 */
export function deleteTodo(branch_id: number, todo_id: number) {
  console.log(
    `Dispatch deleteTodo action for branch id ${branch_id} and todo id ${todo_id}`
  );

  return async (dispatch) => {
    dispatch({ type: TodoActionTypes.TODO_REQUEST });
    try {
      const promise = todosService.deleteTodo(branch_id, todo_id);

      toast.promise(promise, {
        loading: 'Deleting todo...',
        success: () => {
          dispatch({
            type: TodoActionTypes.DELETE_TODO_SUCCESS,
            payload: todo_id,
          });
          return 'Todo deleted!';
        },
        error: (error) => {
          dispatch({
            type: TodoActionTypes.DELETE_TODO_FAILURE,
            payload: error,
          });
          return 'Error deleting todo!';
        },
      });
    } catch (error) {
      dispatch({ type: TodoActionTypes.DELETE_TODO_FAILURE, payload: error });
    }
  };
}
